module.exports = __webpack_public_path__ + "img/earth.e0e705b7.png";